export default __webpack_public_path__ + "static/media/10.3c553b55.png";